/**
 * ver 0.1
 * author jack
 * created 18-12-10
 */
import React from 'react'
import axios from 'axios'
import styled from "@emotion/styled";
import LoginMobileLayer from './loginMobileLayer'
import DefaultMobileLayer from 'common/container/layer/defaultMobileLayer'

class ZzimMobileLayer extends React.Component {
    constructor(props) {
        super(props)

        let { f_div, idx, selected } = props

        this.state = {
            componentUpdate: true,
            f_div,
            idx,
            selected,
            zzimGroups: [],
            selectZzimGroup: 0,
            isLogin: this.props.isLogin,
            showAddGroup: false,
            groupName: '',
            layerError: false,
            defaultLayer: 0,
        }

        this.apiUrl = process.env.REACT_APP_API_URL
        this.config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.componentUpdate
    }

    componentDidMount() {
        if (this.state.selected) {
            let _params = {
                f_div: this.state.f_div,
                idx: this.state.idx,
            }

            axios.post(this.apiUrl + '/front/v2/zzim/del', _params, this.config).then(res => {
                if (res.data.code === 200) {
                    this.onDefaultLayer(2)
                } else {
                    this.setState({ isLogin: false, componentUpdate: true })
                }
            })
        } else {
            axios.get(this.apiUrl + '/front/v2/zzim/group', this.config).then(res => {
                if (res.data.code === 200) {
                    this.setState({
                        zzimGroups: res.data.result,
                        selectZzimGroup: res.data.result[0].gid_zzim,
                        componentUpdate: true,
                    })
                } else {
                    this.setState({ isLogin: false, componentUpdate: true })
                }
            })
        }
    }

    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (this.state.componentUpdate === true) {
            this.setState({ componentUpdate: false })
        }
    }

    onShowAddGroup() {
        this.setState({
            showAddGroup: !this.state.showAddGroup,
            groupName: '',
            componentUpdate: true,
        })
    }

    onAddGroup() {
        let groupName = this.state.groupName
        if (groupName === '') {
            this.setState({ layerError: true })
            return false
        }
        // f_div:99 일경우 그룹 생성 로직
        let _params = {
            f_div: 99,
            gname: groupName,
        }

        axios.post(this.apiUrl + '/front/v2/zzim/save', _params, this.config).then(res => {
            if (res.data.code === 200) {
                this.onDefaultLayer(3)
                this.setState({ zzimGroups: res.data.result, groupName: '', componentUpdate: true })
            } else {
                this.setState({ isLogin: false, componentUpdate: true })
            }
        })
    }

    onAddZzim() {
        let _params = {
            f_div: this.state.f_div,
            idx: this.state.idx,
            gid_zzim: this.state.selectZzimGroup,
        }

        axios.post(this.apiUrl + '/front/v2/zzim/save', _params, this.config).then(res => {
            if (res.data.code === 200) {
                this.onDefaultLayer(1)
            } else {
                this.setState({ isLogin: false, componentUpdate: true })
            }
        })
    }

    onSelectZzimGroup(e) {
        this.setState({ selectZzimGroup: parseInt(e.target.value, 10), componentUpdate: true })
    }

    groupName(e) {
        this.setState({ groupName: e.target.value, componentUpdate: true })
    }

    onDefaultLayer(t) {
        // t = (0 : 닫기, 1 : 찜하기, 2 : 찜삭제, 3 : 찜그룹 등록)
        if (t === undefined) {
            t = 0
            if (this.state.defaultLayer === 2) {
                this.props.onClose(false)
            } else if (this.state.defaultLayer === 1) {
                this.props.onClose(true)
            }
        }
        this.setState({ defaultLayer: t, componentUpdate: true })
    }

    render() {
        if (this.state.isLogin === false)
            return <LoginMobileLayer onClose={() => this.props.onClose(this.state.selected)} />
        if (this.state.defaultLayer === 2) {
            return (
                <DefaultMobileLayer onClose={() => this.onDefaultLayer()}>
                    <strong>
                        해당 상품이 <font className="clrpont1">찜하기에서 제외</font> 되었습니다.
                    </strong>
                </DefaultMobileLayer>
            )
        }


        if (this.state.selected) return false
        // console.log(this.state.showAddGroup);

        return (
            <>
            { this.state.isLogin === true &&
            <React.Fragment>
                <div className="mFullPop">
                    <div className="mFBody">
                        <div className="popTit">
                            <b>상품찜하기</b>
                            <button className="icon-X_close1" onClick={() => this.props.onClose(this.state.selected)} />
                        </div>
                        <div className="popCon mkZzim" style={{ height: 'calc(100% - 162px)' }}>
                            <p>선택한 상품을 그룹에 저장합니다.</p>
                            {this.state.zzimGroups.map((v, i) => {
                                let radioId = 'zzimMRadio_' + i
                                let checked = this.state.selectZzimGroup === v.gid_zzim
                                return (
                                    <div className="zLine" key={i}>
                                        <span className="zLeft">
                                            <strong className="iradio">
                                                <input
                                                    type="radio"
                                                    name={radioId}
                                                    id={radioId}
                                                    checked={checked}
                                                    onChange={e => this.onSelectZzimGroup(e)}
                                                    value={v.gid_zzim}
                                                />
                                                <label htmlFor={radioId}>{v.gname}</label>
                                            </strong>
                                        </span>
                                        <b className="zRight clrbase3">
                                            <em className="clrpont1">{v.cnt}</em>개
                                        </b>
                                    </div>
                                )
                            })}
                            {this.state.showAddGroup && (
                                <div className="zLine prjEvt11">
                                    <input
                                        type="text"
                                        className="zInp"
                                        value={this.state.groupName}
                                        onChange={e => this.groupName(e)}
                                        placeholder="그룹명을 입력하세요."
                                    />
                                    <button className="styWBg zBtn" onClick={() => this.onAddGroup()}>
                                        추가
                                    </button>
                                    <button className="icon-close zBtn" onClick={() => this.onShowAddGroup()} />
                                </div>
                            )}

                            <div className="zzimInfo">
                                <ul>
                                    <li>• 찜한 내역은 각 그룹별 최대 100개까지 저장</li>
                                    <li>• 찜한 내역은 찜 한 날짜로부터 180일동안 저장</li>
                                </ul>
                            </div>
                        </div>
                        <WrapperButton>
                            <ButtonAddGroup onClick={() => this.onShowAddGroup()}>
                                <i className="icon-add_circle" />그룹 추가하기
                            </ButtonAddGroup>
                            <ButtonZzim onClick={() => this.onAddZzim()}>
                                찜하기
                            </ButtonZzim>
                        </WrapperButton>
                    </div>
                </div>
                {this.state.defaultLayer === 1 && (
                    <DefaultMobileLayer onClose={() => this.onDefaultLayer()}>
                        <strong>
                            해당 상품을 <font className="clrpont1">선택한 그룹에 저장</font>하였습니다.
                        </strong>
                    </DefaultMobileLayer>
                )}
                {this.state.defaultLayer === 3 && (
                    <DefaultMobileLayer onClose={() => this.onDefaultLayer()}>
                        <strong>
                            그룹이 <font className="clrpont1">추가</font> 되었습니다
                        </strong>
                    </DefaultMobileLayer>
                )}
            </React.Fragment>
            }
            </>
        )
    }
}
export default ZzimMobileLayer




const WrapperButton = styled.div`
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    position: fixed;
    left: 0;
    bottom: 0;
`

const ButtonAddGroup = styled.button`
    box-sizing: border-box;
    width: 50%;
    height: 48px;
    background-color: #fff;
    border: 1px solid #418DED;
    font-size: 16px;
    color: #418DED;
`
const ButtonZzim = styled.button`
    box-sizing: border-box;
    width: 50%;
    height: 48px;
    background-color: #418DED;
    border: 1px solid #418DED;
    font-size: 16px;
    color: #fff;
`



// WEBPACK FOOTER //
// ./src/common/container/layer/zzimMobileLayer.js